import { NgFor, NgTemplateOutlet } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit, ViewEncapsulation } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatMenuModule } from '@angular/material/menu';
import { Router } from '@angular/router';
import { FuseNavigationItem, FuseNavigationService, FuseVerticalNavigationComponent } from '@fuse/components/navigation';
import { AvailableLangs, TranslocoService } from '@ngneat/transloco';
import { NavigationService } from 'app/core/navigation/navigation.service';
import { filter, switchMap, take, tap } from 'rxjs';

@Component({
    selector       : 'languages',
    templateUrl    : './languages.component.html',
    encapsulation  : ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    exportAs       : 'languages',
    standalone     : true,
    imports        : [MatButtonModule, MatMenuModule, NgTemplateOutlet, NgFor],
})
export class LanguagesComponent implements OnInit
{
    availableLangs: AvailableLangs;
    activeLang: string;
    flagCodes: any;

    /**
     * Constructor
     */
    constructor(
        private readonly _changeDetectorRef: ChangeDetectorRef,
        private readonly _fuseNavigationService: FuseNavigationService,
        private readonly _translocoService: TranslocoService,
        private readonly _navigationService: NavigationService,
        private readonly _router: Router
    )
    {
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------

    /**
     * On init
     */
    ngOnInit(): void
    {
        // Get the available languages from transloco
        this.availableLangs = this._translocoService.getAvailableLangs();        

        // Subscribe to language changes
  this._translocoService.langChanges$
    .pipe(
      filter(Boolean),
      switchMap((activeLang) =>
        this._translocoService.load(activeLang).pipe(
          tap(() => {
            this.activeLang = activeLang;
            this._updateNavigation(activeLang);
            this._changeDetectorRef.markForCheck();
          })
        )
      )
    )
    .subscribe();


        // Set the country iso codes for languages for flags
        this.flagCodes = {
            'en': 'us',
            'es': 'es',
        };
    }


    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Set the active lang
     *
     * @param lang
     */
    setActiveLang(lang: string): void
    {
        // Set the active lang
        this._translocoService.setActiveLang(lang);

        this.reloadComponent(true);
    }


  /**
 

    /**
     * Track by function for ngFor loops
     *
     * @param index
     * @param item
     */
    trackByFn(index: number, item: any): any
    {
        return item.id || index;
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Private methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Update the navigation
     *
     * @param lang
     * @private
     */
   private _updateNavigation(lang: string): void {
        
        const navComponent =
            this._fuseNavigationService.getComponent<FuseVerticalNavigationComponent>('mainNavigation');

        if (!navComponent) return;

        this._navigationService.get()
            .pipe(take(1))
            .subscribe((nav) => {
                
            const items: FuseNavigationItem[] = nav.default; // o nav.compact, nav.horizontal...

            this._fuseNavigationService.storeNavigation('mainNavigation', items);
            navComponent.navigation = items;
            navComponent.refresh();
            });
    }    

    reloadComponent(self:boolean,urlToNavigateTo ?:string){    
        //skipLocationChange:true means dont update the url to / when navigating
        console.log("Current route I am on:",this._router.url);
        const url=self ? this._router.url :urlToNavigateTo;
        this._router.navigateByUrl('/loading',{skipLocationChange:true}).then(()=>{
        this._router.navigate([`/${url}`]).then(()=>{
            console.log(`After navigation I am on:${this._router.url}`)
        })
        })
    }    
}
